import React from "react";
import { DropdownButton } from "../Button";

import accountQuery from "../../utils/queries/accountQuery";
import { Loading } from "../Loader";
import icons from "../../constants/icons";
import { CardHeader } from "../Header";
import { connect } from "react-redux";
import language from "../../language";
import { Checkbox } from "../Input";
import { onResetFilters } from "../../actions/Filters";
import handleSearch from "../../utils/handleSearch";

let copyData = [];

class InstitutionFilter extends React.Component {
  state = {
    isLoading: true,
    data: [],
    page: 1,
    limit: 10,
  };

  componentDidMount = async () => {
    await this.getData(true);
  };

  getData = async (isLoading) => {
    try {
// eslint-disable-next-line no-unused-vars
      const { defaultLanguage, filters = {} } = this.props;
      const { page, limit } = this.state;

      this.setState({ isLoading });

      const { data, count, totalRecords } = await accountQuery(defaultLanguage, {
        page,
        limit,
        dataTypes: ["institutions"],
      });

      this.setState({
        data: data,
        isLoading: false,
        count,
      });

      // const defaultInstitutions = [];

      // institutions.length === 0 &&
      //   data?.forEach((el) => {
      //     if (el.name === institution) defaultInstitutions.push(el);
      //   });

      // if (defaultInstitutions && defaultInstitutions?.length > 0) {
      //   this.props.dispatch(onAddFilter({ institutions: defaultInstitutions }));
      // }

      copyData = data.slice(0);
    } catch (error) {
      console.log(error);
      this.setState({
        isLoading: false,
      });
    }
  };

  onCheck(el) {
    let { filters } = this.props;
    let { institutions = [] } = filters;

    const index = institutions.findIndex((sEl) => sEl.value === el._id);

    if (index === -1) {
      institutions.push({
        value: el._id,
        label: el.name,
      });
    } else {
      institutions.splice(index, 1);
    }

    // this.props.dispatch(
    //   onAddFilter({
    //     institutions,
    //   })
    // );
    this.props.handleApplyFilters &&
      this.props.handleApplyFilters(true, { institutions });
  }

  handleSearch(e) {
    const searchValue = e?.target?.value;
    this.setState({ searchValue });

    let results = [];
    copyData.forEach((el) => {
      if (
        JSON.stringify(el).toLowerCase().indexOf(searchValue.toLowerCase()) !==
        -1
      ) {
        results.push(el);
      }
    });

    this.setState({ data: results });
  }

  render() {
    return (
      <DropdownButton
        leftIcon={icons.institution}
        text={language[this.props.defaultLanguage].institutions}
        className="btn-transparent btn-bordered w-sm-100 btn-sm"
        selectedData={this.props?.filters?.institutions}
        clickOutside
      >
        <CardHeader
          title={language[this.props.defaultLanguage].institutions}
          borderBottom
          closeButton
          isSearch
          reset={
            this.props?.filters?.institutions &&
            this.props?.filters?.institutions?.length > 0
          }
          handleResetFilter={() =>
            this.props.dispatch(onResetFilters("institutions"))
          }
          handleSearch={(e) =>
            handleSearch(this, { copyData, value: e?.target?.value })
          }
        />
        <div className="dropdown-content">
          {this.state.isLoading ? (
            <center>
              <Loading />
            </center>
          ) : (
            this.state?.data?.map((el, i) => {
              return (
                <Checkbox
                  label={el.name}
                  key={i}
                  onCheck={() => this.onCheck(el)}
                  checked={this.props?.filters?.institutions?.find(
                    (sEl) => sEl._id === el._id
                  )}
                />
              );
            })
          )}
        </div>
      </DropdownButton>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(InstitutionFilter);
